import React from "react";

import { TableBody } from "@mui/material";

import { Sort } from "@/components/atoms";
import { StyledFixedLayoutTable, StyledTableContainer } from "@/styles/styled";

import { TableColumProps, TableHead } from "../TableHead";

export type TableProps<ObjectType, SortPropertyType extends string> = {
    items: ObjectType[];
    columns: TableColumProps<ObjectType, SortPropertyType>[];
    orderBy: Sort<SortPropertyType>;
    condensed?: boolean;
    handleSort: (orderBy: SortPropertyType) => void;
    renderItem: (item: ObjectType, index?: number) => React.ReactElement;
};

const Table = <ObjectType, SortPropertyType extends string>({
    items,
    columns,
    handleSort,
    orderBy,
    renderItem,
    condensed = false,
}: TableProps<ObjectType, SortPropertyType>): React.ReactElement => {
    return (
        <StyledTableContainer $condensed={condensed}>
            <StyledFixedLayoutTable id="table">
                <colgroup>
                    {columns.map((column) => (
                        <col width={column.width} key={`table-col-${column.sortableKey || column.unsortableKey}`} />
                    ))}
                </colgroup>
                <TableHead<ObjectType, SortPropertyType> columns={columns} handleSort={handleSort} orderBy={orderBy} />
                <TableBody>{items.map((item, index) => renderItem(item, index))}</TableBody>
            </StyledFixedLayoutTable>
        </StyledTableContainer>
    );
};

export default Table;
